var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9276 105H34.0701C28.5176 105 23.9976 100.482 23.9976 94.9275V43.07C23.9976 37.5175 28.5151 32.9975 34.0701 32.9975H85.9276C91.4801 32.9975 96.0001 37.515 96.0001 43.07V94.9275C96.0001 100.48 91.4826 105 85.9276 105ZM34.0726 39C31.8276 39 30.0001 40.8275 30.0001 43.0725V94.93C30.0001 97.175 31.8276 99.0025 34.0726 99.0025H85.9301C88.1751 99.0025 90.0026 97.175 90.0026 94.93V43.0725C90.0026 40.8275 88.1751 39 85.9301 39H34.0726Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 36H72.0001V30C72.0001 23.3825 66.6176 18 60.0001 18C53.3826 18 48.0001 23.3825 48.0001 30V36H42.0001V30C42.0001 20.075 50.0751 12 60.0001 12C69.9251 12 78.0001 20.075 78.0001 30V36Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 90C54.1826 90 49.4501 85.2675 49.4501 79.45V77.58C44.8151 74.2175 42.0001 68.7775 42.0001 63C42.0001 53.075 50.0751 45 60.0001 45C69.9251 45 78.0001 53.075 78.0001 63C78.0001 68.7775 75.1851 74.215 70.5501 77.58V79.45C70.5501 85.2675 65.8176 90 60.0001 90ZM60.0001 51C53.3826 51 48.0001 56.3825 48.0001 63C48.0001 67.2475 50.2851 71.2225 53.9626 73.3675L55.4501 74.235V79.4475C55.4501 81.9575 57.4926 83.9975 60.0001 83.9975C62.5076 83.9975 64.5501 81.955 64.5501 79.4475V74.235L66.0376 73.3675C69.7151 71.22 72.0001 67.2475 72.0001 63C72.0001 56.3825 66.6176 51 60.0001 51Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePayment);
export default __webpack_public_path__ + "static/media/SafePayment.d77cc29e.svg";
export { ForwardRef as ReactComponent };